import Logo from "./Logo";
import NewPageHeader from "./NewPageHeader";
import PageHeader from "./PageHeader";

const EXPORT = {
  Logo,
  NewPageHeader,
  PageHeader,
};

export default EXPORT;
